import { inject, Injectable } from '@angular/core';
import { HttpResourceRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { endpoints } from '../../environments/endpoints';
import { ApiService } from '../Modules/Shared/Services/api.service';
import { AccessRequestResponse } from '../Interfaces/api/access-request.interface';

@Injectable({
    providedIn: 'root',
})
export class AccessRequestService {
    private readonly _apiService = inject(ApiService);

    status(skipLoading: boolean = true): HttpResourceRequest {
        return this._apiService.get<AccessRequestResponse>(endpoints.api.requestAccess.status, { skipLoading });
    }

    send(skipLoading: boolean = false): Observable<AccessRequestResponse> {
        const request = this._apiService.post<AccessRequestResponse>(endpoints.api.requestAccess.send, { skipLoading });
        return this._apiService.run<AccessRequestResponse>(request);
    }
}
